import { useState, useEffect } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "../snackbar/useSnackbar";
import { googleOauthLogin } from "../../../utils";
import { SnackbarAlert } from "../SnackbarAlert";
import { isAxiosError } from "axios";

export const GoogleButtonAuthenticate = ({
  redirectSignUp,
  handleSignInGoogle = () => { },
  handleGoogleSingUpData = () => { }
}) => {
  const [googleResponse, setGoogleResponse] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const { snackbar, showSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (!googleResponse) return;

    const doLogin = async () => {
      try {
        const data = await googleOauthLogin(
          googleResponse.credential,
          googleResponse.clientId,
          googleResponse.select_by
        ).then((res) => res.data);

        handleSignInGoogle(data)

        if (data?.token?.length > 0 && data?.refresh_token?.token?.length > 0) {
          const { token, refresh_token } = data;
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("refresh_token", refresh_token.token);

          showSnackbar("Signed in successfully", "success");

          setTimeout(() => {
            navigate("/");
            window.location.reload();
          }, 1500);
        }
      } catch (error) {

        const status = error?.response?.data?.data?.status
        const errorCode = error?.response?.data?.status
        const userInfo = error?.response?.data?.data?.userInfo

        if (!isAxiosError(error)) {
          console.error("Google login error:", error);
          showSnackbar("Failed sign up.", "error");
        }

        if (status === "pending" && errorCode === 401) {
          if (
            location.pathname === "/signup/business" ||
            location.pathname === "/signup/individual"
          ) {
            handleGoogleSingUpData(userInfo);
          } else {
            navigate("/signup", { state: { userInfo } });
          }

          showSnackbar("Almost done! Please complete your profile.", "info");
        }
      }
    };

    doLogin();
  }, [googleResponse]);

  return (
    <>
      <GoogleLogin
        onSuccess={(response) => setGoogleResponse(response)}
        onError={(error) => {
          console.error("Google Sign-in Failed:", error);
          showSnackbar("Google sign-in failed", "error");
        }}
        theme="outline"
        size="large"
        shape="rectangular"
        text="signin_with"
      />

      <SnackbarAlert
        openState={snackbar.open}
        setOpenState={closeSnackbar}
        severity={snackbar.severity}
        message={snackbar.message}
        scope="global"
      />
    </>
  );
};
